<template>
  <!--
    O <v-app> e a raiz: ele mesmo marca o `data-app`, que antes era posto
    a mao no div. Com isso dialog, menu e tooltip passam a nascer DENTRO
    do .v-application, que e onde o Vuetify espera - antes ficavam fora e
    nao recebiam nenhum dos utilitarios dele.

    O id continua "app" porque o CSS do projeto mira #app. Ele vai no
    <v-app> em vez de num div por fora: o VApp ja usa id="app" por padrao,
    e os dois juntos deixavam dois elementos com o mesmo id na pagina.
  -->
  <v-app id="app">
    <Loading :loading="loading" />
    <SnackBar
      :show="snack.show"
      :text="snack.msg"
      :type="snack.type"
      @dismissed="onDismissed"
    />
    <Header v-if="!regraExibicao()" @drawer="drawer = !drawer" />
    <Menu v-if="!regraExibicao()" v-model="drawer" />
    <Content />
    <Footer v-if="!regraExibicao()" />
    <!--
      Aviso de expiracao de sessao. Fica no App.vue, e nao no Header, porque
      precisa aparecer tambem nas rotas em que o cabecalho nao e montado.
    -->
    <SessaoExpirandoDialog />
    <!-- Modal de Faturas Pendentes -->
    <DialogFaturasPendentes
      v-if="hasFaturas && showModal"
      :show="showModal"
      @close-modal="showModal = false; marcarModaisComoExibidos()"
      @semFaturas="hasFaturas = false; marcarModaisComoExibidos()"
      @show-modal="showModal = true"
    />
    <!-- Modal de Certificados Próximos do Vencimento -->
    <ModalCertificadosVencimento
      v-if="exibirModalCert"
      :certificados="certificadosVencimento"
      :show="exibirModalCert"
      @close-modal="fecharModalCertificados"
      tituloModal="Certificados Próximos do Vencimento"
      descricaoModal="Os certificados listados abaixo estão a menos de 15 dias do vencimento. Atualize-os o quanto antes!"
    />
  </v-app>
</template>

<script>
import Header from './components/template/Header'
import Menu from './components/template/Menu'
import Content from './components/template/Content'
import Footer from './components/template/Footer'
import LoginService from './service/login'
import { mapGetters, mapActions } from 'vuex'
import SnackBar from './components/SnackBar'
import Loading from './components/Loading'
import ModalCertificadosVencimento from './components/ModalCertificadosVencimento'
import DialogFaturasPendentes from './components/FaturasPendentes'
import SessaoExpirandoDialog from './components/SessaoExpirandoDialog'
import Movimentacao from './service/movimentacao'
import Certificado from './service/certificado'

export default {
  name: 'App',
  components: {
    Header,
    Menu,
    Content,
    Footer,
    SnackBar,
    Loading,
    ModalCertificadosVencimento,
    DialogFaturasPendentes,
    SessaoExpirandoDialog
  },
  data() {
    return {
      certificadosVencimento: [],
      certificadosOK: [],
      hasFaturas: false,
      showModal: false,
      exibirModalCert: false,
      faturasPendentes: null,
      modaisJaExibidos: false
    }
  },
  computed: {
    ...mapGetters(['snack', 'loading']),
    drawer: {
      get() {
        return this.$store.state.drawer
      },
      set(value) {
        this.$store.commit('SET_DRAWER', value)
      }
    }
  },
  async mounted() {
    // Se nao tem token, nao chama goToDashboard nem verifica modais.
    // O usuario esta em login (ou vai ser redirecionado pelo guard) e
    // chamar /user sem token so gera 401 + log poluido no console.
    if (!localStorage.getItem('token')) {
      return
    }
    this.goToDashboard()
    // Só verifica modais se ainda não foram exibidos nesta sessão
    if (!sessionStorage.getItem('modais_exibidos')) {
      await this.verificarCertificados()
      await this.verificarFaturas()
    }
  },
  methods: {
    ...mapActions(['clearSnack', 'usernameAction']),

    onDismissed() {
      this.clearSnack()
    },

    goToDashboard() {
      LoginService.getUser()
        .then((response) => {
          this.usernameAction(response.data)
          localStorage.setItem('id', response.data.id)

          // Só redireciona se estiver na página de login ou se não houver rota definida
          if (this.$route.name === 'Login' || !this.$route.name) {
            if (
              localStorage.getItem('permissoes') !== 'ROLE_MOTORISTA' &&
              localStorage.getItem('permissoes') !== 'ROLE_USUARIO_MDFE_ENCERRAMENTO'
            ) {
              this.$router.push('/')
            } else {
              this.$router.push('/mdfee')
            }
            // Se vier do login, exibe os modais
            this.exibirModaisAposLogin()
          }
          // Se já estiver em qualquer outra página, mantém onde está
        })
        .catch(() => {
          localStorage.clear()
          if (this.$route.name !== 'Login') {
            this.$router.push('/login')
          }
        })
    },

    regraExibicao() {
      return this.$route.name === 'Home' || this.$route.name === 'Login'
    },

    async verificarFaturas() {
      // Se nao tem id (usuario nao logado / sessao expirada), nao adianta
      // ficar polling indefinidamente. Para imediatamente quando o id
      // some - o proximo login dispara a verificacao via exibirModaisAposLogin.
      const idUsuario = localStorage.getItem('id')
      if (!idUsuario) {
        if (this.$route && this.$route.name === 'Login') {
          // Esta na tela de login - aguarda silenciosamente, sem retry
          return
        }
        // Em outras telas, tenta uma vez ate 3s (caso login esteja completando)
        console.log('ID do usuário não encontrado, tentando novamente em 3 segundos...')
        setTimeout(() => this.verificarFaturas(), 3000)
        return
      }

      try {
        const response = await Movimentacao.getAllFaturas()
        this.faturasPendentes = response.data
        console.log('Faturas pendentes recebidas:', this.faturasPendentes)
        if (this.faturasPendentes?.transportadores?.length > 0) {
          this.hasFaturas = true
          this.showModal = true
          console.log('Modal de faturas exibido automaticamente')
        } else {
          this.hasFaturas = false
          this.showModal = false
          console.log('Nenhuma fatura pendente, modal não exibido')
        }
        
        // Emite evento informando que a verificação de faturas foi concluída
        this.$root.$emit('faturas-verificadas')
        
      } catch (error) {
        console.error('Erro ao verificar faturas:', error)
        if (error.response && error.response.status === 400) {
          console.log('Erro 400 detectado, tentando novamente em 3 segundos...')
          setTimeout(() => this.verificarFaturas(), 3000)
        } else {
          // Mesmo em caso de erro, emite o evento para não travar o dashboard
          this.$root.$emit('faturas-verificadas')
        }
      }
    },

    async verificarCertificados() {
      // Mesmo padrao de verificarFaturas: nao polling infinito em /login.
      const idUsuario = localStorage.getItem('id')
      if (!idUsuario) {
        if (this.$route && this.$route.name === 'Login') {
          return
        }
        setTimeout(() => this.verificarCertificados(), 3000)
        return
      }

      const hoje = new Date()
      const vencimento = new Date(hoje)
      vencimento.setFullYear(vencimento.getFullYear() + 1)
      const dataVencimentoFormatada = vencimento.toISOString().split('T')[0]

      try {
        const response = await Certificado.getCertificados(dataVencimentoFormatada, idUsuario)

        const certificados = response.data
        console.log('Certificados recebidos:', certificados)

        this.certificadosVencimento = certificados.filter(cert => {
          const diff = this.calcularDias(cert.dataExpiracao)
          return diff <= 15
        })
        this.certificadosOK = certificados.filter(cert => {
          const diff = this.calcularDias(cert.dataExpiracao)
          return diff > 30
        })

        console.log('Certificados Vencimento:', this.certificadosVencimento)
        console.log('Certificados OK:', this.certificadosOK)

        this.exibirModalCert = this.certificadosVencimento.length > 0
      } catch (error) {
        console.error('Erro ao verificar certificados:', error)
      }
    },

    calcularDias(dataExpiracao) {
      const hoje = new Date()
      const data = new Date(dataExpiracao)
      return Math.ceil((data - hoje) / (1000 * 60 * 60 * 24))
    },

    fecharModalCertificados() {
      this.exibirModalCert = false
      this.marcarModaisComoExibidos()
    },

    marcarModaisComoExibidos() {
      // Marca que os modais já foram exibidos nesta sessão
      sessionStorage.setItem('modais_exibidos', 'true')
    },

    // Método para ser chamado quando login for bem-sucedido
    async exibirModaisAposLogin() {
      // Só exibe se não foram exibidos nesta sessão
      if (!sessionStorage.getItem('modais_exibidos')) {
        await this.verificarCertificados()
        await this.verificarFaturas()
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #ffffff;
  width: 100%;
  height: 100vh;
}

/*
  Botao desabilitado sumindo no fundo claro.

  `<v-btn dark>` marca o botao com theme--dark, e o Vuetify pinta o
  estado desabilitado com as cores do tema ESCURO: texto branco a 30%
  sobre fundo branco a 12%. Num card claro isso e invisivel - o usuario
  nao ve que existe um botao ali, so o texto que explica por que ele
  esta bloqueado.

  O `dark` costuma estar ali so pra deixar o texto branco enquanto o
  botao esta ativo, entao trocar prop por prop em 34 pontos seria
  arriscado e ruidoso. Esta regra corrige o estado desabilitado em
  todos de uma vez, mantendo o ativo como esta.

  As cores sao as mesmas que o Vuetify usa no tema claro.
*/
.v-application .v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: rgba(0, 0, 0, 0.12) !important;
  color: rgba(0, 0, 0, 0.26) !important;
}

/* Otimizações globais de espaçamento */

.v-card .v-card-text {
  padding: 8px !important;
}

.v-main__wrap {
  padding: 0 !important;
}

.v-container.fluid {
  padding: 1px !important;
}

.container {
  padding: 1px !important;
}

.container.grid-list-xl .layout .flex {
  padding: 1px !important;
}

/* Neutralizar margens negativas que o Vuetify aplica em campos textarea/filled */
.v-textarea .v-text-field__slot,
.v-text-field--enclosed .v-text-field__slot {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.v-textarea textarea {
  margin: 0 !important;
}

/* Neutralizar margin negativa padrão de .row (-12px em chunk-vendors) para alinhamento dos filtros */
.row {
  margin: 0 !important;
}

/* Aproximar filtros do header */
.v-main > .v-container {
  padding-top: 0 !important;
  margin-top: 0 !important;
}

.v-row {
  margin: 0 !important;
}

.v-col {
  padding: 4px 8px !important;
}

/* Reduzir espaçamento específico dos filtros */
.v-text-field, .v-select, .v-autocomplete {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

.v-input__control {
  min-height: 40px !important;
}

/* Compactar tabelas */
.v-data-table {
  margin-top: 8px !important;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 4px 8px !important;
}

/* Compactar cards */
.v-card {
  margin-bottom: 8px !important;
}

.v-card .v-app-bar {
  min-height: 36px !important;
}

/* Compactar layout geral */
.v-layout {
  margin: 0 !important;
}

.v-flex {
  padding: 2px !important;
}

/* Aproximar primeiro card do header */
.v-main .v-container > .v-layout > .v-flex:first-child {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.v-main .v-container > .v-layout > .v-flex:first-child .v-card {
  margin-top: 0 !important;
}
</style>